import { MEDIA_TYPE, MAX_CAROUSEL_IMAGES } from './constants';
import { generateAlternativeSrc, generateImage } from './content/images';
import { getProductCardAttributes } from './content/splashes';
import { parseProductThumbnailsAndColors } from './content/variants';

export const getAlternativeImage = (media) => {
    if (!media?.length) {
        return null;
    }

    const [alternativeImage] = media.filter(({ type }) => type === MEDIA_TYPE.alternativeImage);

    return alternativeImage ?? null;
};

export const isProductCardCarouselEnabled = (isMobile, isImagesCarouselFeatureActive) => (
    isMobile && isImagesCarouselFeatureActive
);

const hasVideo = media => media?.find(({ type }) => type === MEDIA_TYPE.video);

export const getImagesForProductCardCarousel = (media = [], cardConfig) => {
    const hasMediaVideo = hasVideo(media);

    if (!cardConfig.showMobileImagesCarousel || hasMediaVideo) {
        return [];
    }

    return media
        .slice(0, MAX_CAROUSEL_IMAGES)
        .map(image => generateImage(cardConfig.imagesParameters, image));
};

const getCategoryByBreadcrumbs = (breadcrumbs) => {
    if (!breadcrumbs?.length) {
        return '';
    }

    return breadcrumbs[breadcrumbs.length - 1]?.name;
};

export const parseDataForProductCard = (product, cardConfig, breadcrumbs) => {
    if (!product?.variants?.[0]) {
        return false;
    }

    const {
        display_name: displayName,
        variants,
        product_name: productName,
        color_name: colorName,
        swatch_id: swatchId,
        brand_name: brandName
    } = product;

    const {
        attribute,
        in_stock: isInStock,
        teaser_date: teaserDate,
        media
    } = variants[0];

    const { colorSwatches } = cardConfig || {};
    const { label: swatchColorName } = colorSwatches?.[swatchId] ?? {};

    const alternativeImage = getAlternativeImage(media);

    const { thumbnails, colors } = parseProductThumbnailsAndColors(product, cardConfig);
    const carouselImages = getImagesForProductCardCarousel(media, cardConfig);

    const productCategory = getCategoryByBreadcrumbs(breadcrumbs);

    const data = {
        brandName,
        productName: cardConfig.hideProductName ? null : displayName,
        alternativeImage: generateAlternativeSrc(alternativeImage, cardConfig),
        colors,
        attributes: getProductCardAttributes(attribute, cardConfig, isInStock),
        teaserDate,
        altText: `${brandName} ${productName} - ${productCategory} - ${colorName} / ${swatchColorName}`,
        media
    };

    return { carouselImages, data, thumbnails };
};
